import { render, staticRenderFns } from "./CatalogComplexCardWrapper.vue?vue&type=template&id=6dc26dba"
import script from "./CatalogComplexCardWrapper.vue?vue&type=script&lang=js"
export * from "./CatalogComplexCardWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports